import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESPROMO,
  DELETE_SALESPROMO,
  UPDATE_SALESPROMO,
  ADD_NEW_SALESPROMO,
} from "./actionType";

import {
  getSalesPromoSuccess,
  getSalesPromoFail,
  deleteSalesPromoSuccess,
  deleteSalesPromoFail,
  updateSalesPromoSuccess,
  updateSalesPromoFail,
  addSalesPromoSuccess,
  addSalesPromoFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveSalesPromoApi,
  getSalesPromoApi,
  updateSalesPromoApi,
  deleteSalesPromoApi,
  addNewSalesPromoApi
} from "../../helpers/backend_helper";

function* getSalesPromo({ payload: salesPromo }) {
  try {
    const response = yield call(getSalesPromoApi, salesPromo);
    yield put(getSalesPromoSuccess(GET_SALESPROMO, response.data));
  } catch (error) {
    yield put(getSalesPromoFail(GET_SALESPROMO, error));
  }
}

function* onUpdateSalesPromo({ payload: salesPromo }) {
  try {
    if (salesPromo.setApprove) {
      const response = yield call(approveSalesPromoApi, salesPromo);
      yield put(updateSalesPromoSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesPromoApi, salesPromo);
      yield put(updateSalesPromoSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesPromoFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesPromo({ payload: salesPromo }) {
  try {
    const response = yield call(deleteSalesPromoApi, salesPromo);
    yield put(deleteSalesPromoSuccess({ salesPromo, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesPromoFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesPromo({ payload: salesPromo }) {
  try {
    const response = yield call(addNewSalesPromoApi, salesPromo);
    yield put(addSalesPromoSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesPromoFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesPromo() {
  yield takeEvery(GET_SALESPROMO, getSalesPromo);
}

export function* watchUpdateSalesPromo() {
  yield takeEvery(UPDATE_SALESPROMO, onUpdateSalesPromo);
}

export function* watchDeleteSalesPromo() {
  yield takeEvery(DELETE_SALESPROMO, onDeleteSalesPromo);
}

export function* watchAddNewSalesPromo() {
  yield takeEvery(ADD_NEW_SALESPROMO, onAddNewSalesPromo);
}

function* salesPromoSaga() {
  yield all([
    fork(watchGetSalesPromo),
    fork(watchDeleteSalesPromo),
    fork(watchUpdateSalesPromo),
    fork(watchAddNewSalesPromo)
  ]);
}

export default salesPromoSaga;
